import { Box, Typography } from "@mui/material";

type AddressValue = {
  street?: string | null;
  zip_code?: string | null;
  city?: string | null;
  country?: string | null;
};

type GridAddressCellProps = {
  address?: AddressValue | null;
  addressText?: string | null;
  singleLine?: boolean;
};

const normalizePart = (value?: string | null) => value?.trim() || "";

export default function GridAddressCell({
  address,
  addressText,
  singleLine = false,
}: GridAddressCellProps) {
  const street = normalizePart(address?.street);
  const zipCode = normalizePart(address?.zip_code);
  const city = normalizePart(address?.city);
  const formattedAddressText = normalizePart(addressText);

  if (singleLine) {
    if (!formattedAddressText) {
      return null;
    }

    return (
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", lineHeight: 1.1 }}
      >
        {formattedAddressText}
      </Typography>
    );
  }

  const locationParts = [zipCode, city]
    .filter(Boolean)
    .join(" ");

  if (!street && !locationParts) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
      {street ? (
        <Typography variant="body2" sx={{ lineHeight: 1.1 }}>
          {street}
        </Typography>
      ) : null}
      {locationParts ? (
        <Typography variant="caption" color="text.secondary">
          {locationParts}
        </Typography>
      ) : null}
    </Box>
  );
}
